import React from 'react';
import { PurchaseOrderItemStatus, PurchaseOrderItem, PurchaseOrder } from '@domain/purchasing';
import { POItemGroups } from '@domain/purchasing/models/PurchaseOrderItemGroups';

export interface KanbanColumn {
  id: PurchaseOrderItemStatus;
  title: string;
  subtitle?: string;
  color: string;
  icon: React.ReactNode;
}

export interface KanbanProps {
  groupedItems?: POItemGroups[];
  onReorderItems?: (columnId: PurchaseOrderItemStatus, newOrder: Array<{ item: PurchaseOrderItem }>) => void;
  onStatusChange?: (item: PurchaseOrderItem, newStatus: PurchaseOrderItemStatus) => void;
}

export type Step = 'products' | 'shipping' | 'quantity' | 'summary' | 'create-shipment' | 'add-to-shipment';

export enum GroupingOption {
  PURCHASE_ORDER = 'purchaseOrder',
  PRODUCT = 'product',
  SHIPMENT = 'shipment',
  SUPPLIER = 'supplier',
  NO_GROUPING = 'noGrouping'
}